import { CSSProperties } from "react";
import { Form } from "antd";
import styled from "styled-components";
import theme from "styles/theme";

const { Item } = Form;
export const FormLayout: CSSProperties = {
  height: "100%",
};

export const LayoutForm = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 0px;

  .ant-form-item {
    margin-bottom: 7px !important;
  }

  .ant-tabs-nav-list {
    display: flex;
    gap: 18px;
  }

  .ant-btn-default {
    color: ${(props) => props.theme["@default-color"]};
    font-size: ${(props) => props.theme["@large-font-size"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    border: 1px solid ${(props) => props.theme.colors.text} !important;
    height: 48px !important;
    :hover,
    :focus {
      background-color: ${(props) => props.theme["@hover-input-background-color"]} !important;
      border: none !important;
      color: ${(props) => props.theme["@default-color"]};
      box-shadow: none;
    }
  }

  .ant-btn-primary {
    color: ${(props) => props.theme["@default-color"]};
    font-size: ${(props) => props.theme["@large-font-size"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    border: none;
    :hover,
    :focus {
      color: ${(props) => props.theme["@default-color"]};
      background-color: ${(props) => props.theme["@hover-input-background-color"]};
      border: none;
      box-shadow: none;
    }
  }

  .ant-btn.ant-btn-default {
    height: ${(props) => props.theme["@height-button-lg"]} !important;
    color: ${(props) => props.theme["@default-color"]};
  }

  .ant-btn.ant-btn-primary {
    height: ${(props) => props.theme["@height-button-lg"]} !important;
    color: ${(props) => props.theme["@default-color"]};
  }

  .ant-tabs-ink-bar.ant-tabs-ink-bar-animated {
    background-color: ${(props) => props.theme["@primary-color-brand"]} !important;
  }
`;

export const FormContainer = styled.div`
  margin-bottom: 50px;
`;

export const FakeBtnConfirm = {
  display: "none",
};

export const DrawerFooter = styled.div`
  width: 100%;
  padding: 10px 24px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  background-color: ${(props) => props.theme["@footer-background"]};
  .left {
    text-align: left;
  }
  .right {
    text-align: right;
    display: flex;
    margin-left: auto;
    gap: ${(props) => props.theme["@spacing-size-3xs"]} !important;
  }
  .btn,
  .ant-btn-primary {
    height: ${(props) => props.theme["@height-button-lg"]};
    width: 140px;
    color: ${(props) => props.theme["@default-color"]};
    font-size: ${(props) => props.theme["@large-font-size"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    border: none;
    :hover,
    :focus {
      color: ${(props) => props.theme["@default-color"]};
      background-color: ${(props) => props.theme["@hover-input-background-color"]};
      border: none;
    }
  }
  .btnCancel,
  .ant-btn-default {
    height: ${(props) => props.theme["@height-button-lg"]};
    width: 140px;
    color: ${(props) => props.theme["@default-color"]};
    font-size: ${(props) => props.theme["@large-font-size"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    border: 1px solid ${(props) => props.theme.colors.text} !important;
    border-radius: ${(props) => props.theme["@border-radius-base"]};
    height: 48px !important;
    :hover,
    :focus {
      background-color: ${(props) => props.theme["@hover-input-background-color"]} !important;
      border: none !important;
      color: ${(props) => props.theme["@default-color"]};
    }
  }
`;

export const CloseDrawer = styled.span`
  .closeIcon > svg {
    color: ${(props) => props.theme["@input-border-color"]} !important;
    cursor: pointer !important;
    :hover {
      color: ${(props) => props.theme.colors.text} !important;
    }
  }
`;

export const TitleDescription = styled.div`
  font-size: 16px;
  margin-bottom: 15px;
`;

export const ProcessDescription = styled.div`
  font-size: 13px;
  margin-bottom: 8px;
`;

export const Description = styled.div`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 6px;
`;

export const VehicleStepsContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 15px;
  margin-top: 15px;
  .ant-checkbox-wrapper {
    margin: 0;
  }
`;

export const ProcessTitle = styled.div`
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 15px;
`;

export const ConfigurationDescription: CSSProperties = {
  maxWidth: "100%",
  fontFamily: theme["@font-family"],
  fontWeight: theme["@normal-font-weight"],
  padding: "3px 0",
  zIndex: 1,
  marginRight: "5px",
  fontSize: theme["@medium-font-size"],
};

export const DocumentsContainer = styled.div`
  display: flex;
  margin-top: 15px;
  row-gap: 15px;
  flex-direction: column;
  .ant-checkbox-wrapper {
    margin: 0;
  }
`;

export const RequiredDocumentContainer = styled.div`
  margin-top: 8px;
`;

export const FormItemFieldName = styled(Item)`
  .ant-input {
    margin-left: 0;
    font-size: ${(props) => props.theme["@medium-font-size"]};

    &:hover,
    &:focus {
      border-color: ${(props) => props.theme["@primary-color-brand"]};
    }

    box-shadow: none;

    &:hover {
      border-color: ${(props) => props.theme["@secondary-color"]};
    }
  }

  .ant-form-item-control {
    width: 100%;
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]};
    height: ${(props) => props.theme["@height-input-lg"]};
    &:hover,
    &:focus {
      border-color: ${(props) => props.theme["@primary-color-brand"]} !important;
    }
  }
  .ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer) .ant-select-selector {
    border: 1.6px solid ${(props) => props.theme["@danger-color"]} !important;
    background-color: ${(props) => props.theme["@danger-background"]};
    :hover {
      border-color: ${(props) => props.theme["@danger-color"]};
      background-color: ${(props) => props.theme["@danger-background"]} !important;
    }
  }
  .ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector,
  .ant-input[disabled] {
    background: ${(props) => props.theme["@input-background-disabled"]};
    color: ${(props) => props.theme["@profile-text-color"]};
    cursor: default;
    :hover {
      border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
    }
  }
  .ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer).ant-select-focused .ant-select-selector,
  .ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer).ant-select-open .ant-select-selector {
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    outline: 1.6px solid ${(props) => props.theme.colors.text};
    outline-offset: 1.6px;
    align-items: center;
  }

  .ant-form-item-label {
    display: flex !important;
    min-width: 100%;
    max-width: 100%;
    padding: 6px 0;
    height: auto !important;
    z-index: 1;
    pointer-events: none !important;

    > label {
      font-family: ${(props) => props.theme["@font-family"]};
      font-size: ${(props) => props.theme["@medium-font-size"]};
      font-weight: ${(props) => props.theme["@bold-font-weight"]};
      line-height: 1.4;
    }
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: 1px solid ${(props) => props.theme.colors.manatee};
  }

  .ant-form-item-required::before {
    content: "" !important;
  }
`;
